import { SIMDocumentTypeAttachmentOption, backendServices } from 'common';
import { SIM_DOCUMENT_CLASS } from './_shared/simDocumentVM';
import { findScheduleForClass } from './simSchedules';

/** Per-step attachment behavior derived from the buyer's SIM schedules. */
export interface SimAttachmentOptions {
    taxDetails: SIMDocumentTypeAttachmentOption;
    remittance: SIMDocumentTypeAttachmentOption;
    certificateOfInsurance: SIMDocumentTypeAttachmentOption;
}

function resolveForClass(
    schedules: backendServices.ViewModels.SIMDocumentTypeScheduleViewModel[],
    documentClass: number
): SIMDocumentTypeAttachmentOption {
    return (
        findScheduleForClass(schedules, documentClass)?.AttachmentOption ??
        SIMDocumentTypeAttachmentOption.NoAttachments
    );
}

export function resolveSimAttachmentOptions(
    schedules: backendServices.ViewModels.SIMDocumentTypeScheduleViewModel[]
): SimAttachmentOptions {
    return {
        taxDetails: resolveForClass(schedules, SIM_DOCUMENT_CLASS.W9),
        remittance: resolveForClass(schedules, SIM_DOCUMENT_CLASS.Remittance),
        certificateOfInsurance: resolveForClass(schedules, SIM_DOCUMENT_CLASS.InsuranceCertificate),
    };
}

/** Attachment option per questionnaire, keyed by `BusinessDocSubTypeId` (the schedule's `DocumentClass`). */
export function resolveQuestionnaireAttachmentOptions(
    schedules: backendServices.ViewModels.SIMDocumentTypeScheduleViewModel[],
    subTypeIds: number[]
): Record<number, SIMDocumentTypeAttachmentOption> {
    return Object.fromEntries(subTypeIds.map((subTypeId) => [subTypeId, resolveForClass(schedules, subTypeId)]));
}
